<template>
    <div class="box-offset">
        <div class="box-ttl-wrap">
            <div class="box-ttl ">
                Send a message to the ORNA office.
            </div>
        </div>
        <div>
            <p>Please let us know how we can help with as much detail as possible. Please include your email so we can contact you if we need to.</p>
            <ValidationObserver ref="form" class="row">
                <div class="col-md-12">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Who is this message for?</label>
                        <input type="text" v-model="form.message_for" class="form-control">
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Type your message below:</label>
                        <textarea type="text" v-model="form.message" class="form-control height-2"></textarea>
                    </div>
                </div>
                <ValidationProvider
                    name="Email"
                    rules="email"
                    v-slot="{ errors }"
                    class="col-md-6">
                    <div class="form-group form-group-1">
                        <label for="" class="form-label">Email</label>
                        <input type="text" class="form-control" v-model="form.email" placeholder="type your email">
                        <FormError :error="errors[0]" name="Email"></FormError>
                    </div>
                </ValidationProvider>
            </ValidationObserver>
            <div class="row">
                <div class="col-12">
                    <div class="btns-wrap">
                        <button  class="btn btn--outline-primary w-100 w-sm-auto" @click="reloadPage">Cancel</button>
                        <button  class="btn btn--secondary w-100 w-sm-auto" @click="validateForm">Send</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmployeeInfoService from "../services/EmployeeInfoService";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";

export default {
    name: 'EmployeeSupport',
    mixins: [ModalHandler],
    data() {
        return {
            form: {
                message_for: null,
                message: null,
                email: null,
            }

        }
    },
    methods: {
        async validateForm () {
            const form = this.$refs.form
            const valid = await form.validate();
            if (!valid) {
                this.$showErrorMessage('Your email is not correct')
                return;
            }
            await this.sendMessage()
        },

        async sendMessage() {
            this.$showLoadingMessage()
            try {
                await EmployeeInfoService.sendSupportRequest(this.form)
                this.$showSuccessMessage('Your request was sent')
                this.form.message = null
                this.form.message_for = null
                this.form.email = null
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Your request was not sent')
            }

        }
    }
}

</script>


<style scoped>

</style>
